import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  LOADING_CHANGE,
  ON_FORM_CHANGE,
  SET_API_DATA,
  SET_ERROR,
} from "../redux/constants";
import { ApiContainer } from "../utils/api";
import { imagesToLoad } from "../description/assessment.description";
import { keys, length } from "../utils/javascript";
import { assessmentIds } from "../utils/constant";
import {
  getAssessmentState,
  getSlug,
  setErrors,
  toggleModelShow,
} from "../shared/CustomFunc";
import { checkValid } from "../shared/validation";

export const dashBoardResultContainer = () => {
  const { api } = ApiContainer();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectGenderFormPath = { parent: "selectGenderData" };
  const modelState = useSelector((state) => state.modelStates);
  const apiData = useSelector((state) => state?.api);
  const markerInfo = useSelector((state) => state?.api?.markerInfo);
  const userRoleData = useSelector((state) => state.app.userData);
  const { form } = useSelector((state) => state);
  const { formData, formErrors } = form;
  const selectGenderInfo = formData?.[selectGenderFormPath.parent];
  const selectGenderInfoError = formErrors?.[selectGenderFormPath.parent];
  const [resultInfo, setResultInfo] = useState({});
  const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);

  const [readMore, setReadMore] = useState(false);
  const [activeCards, setActiveCards] = useState({ start: -1, end: 3 });
  const vasanaTypeAssessment = getAssessmentState({
    assessments: userRoleData?.assessments,
    id: assessmentIds?.vasanaType,
  });
  const result = useSelector(
    (state) => state?.api?.assessmentResult?.[assessmentIds?.vasanaType]
  );
  const allAssessmentResults = useSelector(
    (state) => state?.api?.assessmentResult
  );

  const assessmentsCardData = useSelector(
    (state) => state?.api?.assessmentsCardData
  );

  const notificationData = useSelector((state) => state?.api?.notificationData);
  const NotificationContent = useSelector(
    (state) => state.api?.NotificationContent
  );

  const assessmentCardLoader = useSelector(
    (state) => state?.api?.loader?.assessmentCard
  );

  const loaders = useSelector((state) => {
    return {
      notification: state.api?.loader?.notification,
    };
  });

  const toggleReadMore = () => {
    setReadMore(!readMore);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (result && markerInfo) {
      setResultInfo({ ...markerInfo?.[result?.result?.toLowerCase()] });
    }
  }, [result, markerInfo]);

  useEffect(() => {
    imagesToLoad.forEach((src) => {
      const imageToLoad = new Image();
      imageToLoad.src = `${process.env.REACT_APP_MEDIA_URL}${src}`;
    });
  }, []);

  const getAssessmentCardData = async () => {
    const response = await api({
      method: "GET",
      endPoint: "assessment/assessment-cards",
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "assessmentCard",
    });
    if (response?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          assessmentsCardData:
            response?.data?.message === "No Data Found"
              ? []
              : response?.data || [],
        },
      });
    }
  };

  const getNotificationData = async () => {
    const response = await api({
      method: "GET",
      endPoint: "user/notifications",
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "notification",
    });
    if (response?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          notificationData:
            response?.data?.message === "No data found"
              ? []
              : response?.data || [],
        },
      });
    }
  };

  useEffect(() => {
    getAssessmentCardData();
    getNotificationData();
  }, []);

  const handleButtonClick = (name, assessmentId, type, submissionId) => {
    localStorage.setItem("currentAssessmentId", assessmentId);
    if (
      (name.includes("Hormone Health Assessment") ||
        name.includes("Medical History Questionnaire")) &&
      userRoleData?.user_profile?.gender !== "Male" &&
      userRoleData?.user_profile?.gender !== "Female"
    ) {
      if (!name.includes("male")) {
        dispatch(toggleModelShow("GenderChangeModal"));
      } else {
        const slug = getSlug(apiData?.assessmentList, assessmentId);
        navigate(`/get-started/${slug}`);
      }
      return;
    }
    if (submissionId) {
      navigate(`/assessments/${assessmentId}`);
    } else {
      const slug = getSlug(apiData?.assessmentList, assessmentId);
      navigate(`/get-started/${slug}`);
    }
  };

  const getData = async (endPoint, key) => {
    if (!apiData?.[key]?.[assessmentIds?.vasanaType]) {
      const response = await api({
        method: "GET",
        endPoint,
        showToastMessage: false,
        urlencoded: false,
        needLoader: true,
        parent: key,
      });

      if (response?.status) {
        dispatch({
          type: SET_API_DATA,
          payload: {
            [key]: {
              ...allAssessmentResults,
              [assessmentIds?.vasanaType]: response?.data,
            },
          },
        });
      }
    }
  };

  useEffect(() => {
    if (
      length(keys(vasanaTypeAssessment)) &&
      vasanaTypeAssessment?.submission_id
    ) {
      getData(
        `assessment/${assessmentIds?.vasanaType}/result?submission_id=${vasanaTypeAssessment?.submission_id}`,
        "assessmentResult"
      );
    }
  }, [vasanaTypeAssessment]);

  const handleVideoPlay = (index) => {
    setCurrentPlayingIndex(index);
  };

  const handleAssessmentClick = ({ assessmentId, type }) => {
    localStorage.setItem("currentAssessmentId", assessmentId);
    const slug = getSlug(apiData?.assessmentList, assessmentId);
    navigate(`/get-started/${slug}`);
  };

  const toggleReport = ({ assessmentId }) => {
    navigate(`/assessments/${assessmentId}`);
  };

  // useEffect(() => {
  //   if (loaders?.notification && NotificationContent) {
  //     getNotificationData();
  //     dispatch({ type: LOADING_CHANGE, payload: { notification: false } });
  //   }
  // }, [loaders?.notification]);

  const handleNotificationClick = async (notification, action) => {
    let notificationIds = [];

    if (typeof notification?.map === "function") {
      notificationIds = notification
        ?.filter((item) => !item.is_read)
        ?.map((item) => item.id);

      const data = await api({
        method: "PUT",
        endPoint: `notification/is-read`,
        data: { notification_ids: notificationIds },
        urlencoded: false,
      });
      if (data?.status) {
        getNotificationData();
        // dispatch({ type: LOADING_CHANGE, payload: { notification: true } });
      }
    } else {
      notificationIds = [notification?.id];

      dispatch({
        type: SET_API_DATA,
        payload: {
          NotificationContent: notification,
        },
      });
      if (action !== "markAsRead") {
        dispatch(toggleModelShow("NotificationReadModal"));
      }

      if (!notification.is_read) {
        const data = await api({
          method: "PUT",
          endPoint: `notification/is-read`,
          data: { notification_ids: notificationIds },
          urlencoded: false,
        });
        if (data?.status) {
          getNotificationData();
          // dispatch({ type: LOADING_CHANGE, payload: { notification: true } });
        }
      }
    }
  };

  const handleNotificationClose = () => {
    dispatch(toggleModelShow("NotificationReadModal"));
    dispatch({
      type: SET_API_DATA,
      payload: {
        NotificationContent: {},
      },
    });
  };

  const handleGenderModalClose = () => {
    dispatch(toggleModelShow("GenderChangeModal"));
  };

  const genderOption = [
    { key: "Male", value: "male" },
    { key: "Female", value: "female" },
  ];

  const selectGenderFields = {
    data: [
      {
        question: "Select Gender",
        description:
          "To continue with the Hormone Health Assessment, please provide your gender as assigned at birth.",
        value: [
          {
            control: "select",
            label: "Gender",
            name: "gender",
            value: 0,
            validateAs: "selectMenu",
            isRequired: true,
            fullWidth: true,
            placeHolder: "Select gender",
            errorMessage: "please select any gender",
            options: genderOption,
            md: 6,
            variant: "standard",
          },
        ],
      },
    ],
  };

  const handleSelectGender = async () => {
    let errors = {};
    selectGenderFields?.data?.forEach((item) => {
      Object.values(item.value)?.forEach((control) => {
        const { name, validateAs, label } = control;
        errors = {
          ...errors,
          [name]: validateAs
            ? checkValid({
                validateAs,
                name,
                value: selectGenderInfo?.[name],
                label,
              })
            : false,
        };

        dispatch({
          type: SET_ERROR,
          payload: {
            formErrors: {
              ...form.formErrors,
              [selectGenderFormPath.parent]: { ...errors },
            },
          },
        });
      });
    });
    if (selectGenderInfo?.gender) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          SelectedGender: selectGenderInfo?.gender,
        },
      });
      localStorage.setItem("gender", selectGenderInfo?.gender);
      const slug = getSlug(apiData?.assessmentList, 22);
      navigate(`/get-started/${slug}`);
      dispatch(toggleModelShow("GenderChangeModal"));
    }
  };

  const setGenderData = (name, value) => {
    dispatch(
      setErrors({
        errors: selectGenderInfoError ?? {},
        value,
        name,
        formPath: selectGenderFormPath,
      })
    );
    dispatch({
      type: ON_FORM_CHANGE,
      payload: {
        formData: {
          ...form.formData,
          [selectGenderFormPath.parent]: {
            ...selectGenderInfo,
            [name]: value,
          },
        },
      },
    });
  };

  const handelGenderChange = (e) => {
    const { name, value } = e.target;
    setGenderData(name, value);
  };

  const ButtonsForGender = [
    {
      label: "Save",
      handleClick: handleSelectGender,
      hasLoader: true,
      disabled: false,
    },
  ];

  return {
    result,
    markerInfo,
    readMore,
    toggleReadMore,
    resultInfo,
    userRoleData,
    currentPlayingIndex,
    handleVideoPlay,
    setCurrentPlayingIndex,
    vasanaTypeAssessment,
    // onActiveIndexChange,
    activeCards,
    assessmentsCardData,
    assessmentCardLoader,
    notificationData,
    handleAssessmentClick,
    toggleReport,
    modelState,
    handleNotificationClick,
    NotificationContent,
    handleNotificationClose,
    handleGenderModalClose,
    handleButtonClick,
    ButtonsForGender,
    selectGenderFields,
    handleSelectGender,
    handelGenderChange,
    selectGenderInfo,
    selectGenderInfoError,
  };
};

export default dashBoardResultContainer;
